import { render, staticRenderFns } from "./FreightPage.vue?vue&type=template&id=2d8b2525&scoped=true&"
import script from "./FreightPage.vue?vue&type=script&lang=js&"
export * from "./FreightPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8b2525",
  null
  
)

export default component.exports